<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'banners-pages-container',
};
</script>
